// Pages
import CreateTransaction from './pages/CreateTransactionOnePage'; // TODO Simple version (one page)
// import CreateTransaction from './pages/CreateTransaction';
import TransactionHistory from './pages/TransactionHistory';

// Routes
export const appRoutes = [
  {
    name: 'mobile',
    path: '/mobi',
    forwardTo: 'receiver.mobile.history',
    children: [
      {
        name: 'createTransaction',
        path: '/create',
        comp: CreateTransaction,
      },
      {
        name: 'history',
        path: '/history',
        comp: TransactionHistory,
      }
    ],
  },
];
